var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomLayerFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14251 0.929156L0.908698 7.9855C0.508783 8.65203 0.988896 9.5 1.76619 9.5H10.2338C11.0111 9.5 11.4912 8.65203 11.0913 7.9855L6.85749 0.929155C6.46909 0.281816 5.53091 0.281817 5.14251 0.929156Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLayerFill);
export default __webpack_public_path__ + "static/media/custom_layer_fill.3a9e7b3caee60ccf3d8a2101a3575a73.svg";
export { ForwardRef as ReactComponent };